import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CreateAnswerTypes } from './model';

export const useSubmitReply = (
    answerId: number,
): UseMutationResult<CreateAnswerTypes, unknown, CreateAnswerTypes> =>
    useBffPostMutation<CreateAnswerTypes, CreateAnswerTypes>(
        `/turn-to/replies/${answerId}`,
        [],
        [BffQueryKey.TURN_TO_DATA],
    );
